//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'article-item',
  components: {},
  props: ['data'],
  mounted() {
  },
  methods: {
    click() {
      this.$emit('click');
    }
  },
  data() {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/components/app/articleItem.vue